import { Link } from "@solarwinds-webbiz/types";
import { FC, ReactNode } from "react";
import { getDataLinkAttributes } from "@/helpers";
import { Arrow } from "@/icons";

type CategoryTabItem = {
  title?: string;
  links?: Omit<Link, "href">[];
  cta?: ReactNode;
  setSubTab: (num: number) => void;
  closeMenu?: () => void;
};

const MobileNavigationCategoryTabItem: FC<CategoryTabItem> = ({
  title,
  links,
  cta,
  setSubTab,
  closeMenu,
}) => {
  return (
    <>
      {title && (
        <div className="border-swdc-silver-300 text-subhead-2xs text-swdc-black-600 flex flex-row gap-x-2 border-l-8 border-solid py-4 pr-6 pl-4 font-bold">
          {title}
        </div>
      )}
      <ul>
        {links?.map((link, index) => (
          <li
            key={`${link.title}-${index}`}
            className="border-swdc-silver-300 border-l-8 border-solid"
          >
            {link.title ? (
              <button
                onClick={() => setSubTab(index)}
                {...getDataLinkAttributes({ ...link })}
                className="text-link-m text-swdc-black-600 active:text-swdc-blue-500 flex w-full flex-row items-center justify-between py-4 pr-6 pl-4 leading-5 hover:underline active:underline"
              >
                {link.title}
                <Arrow className="fill-swdc-gray-400 ml-2 h-3 w-[1.488rem]" />
              </button>
            ) : (
              cta && closeMenu && <div className="py-4 pr-5 pl-4">{cta}</div>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};

export default MobileNavigationCategoryTabItem;
